import api from './api'
import { getIdFromSlug } from './blog-article';

const url = '/blogs/'

export const getBlogRelatedArticles = async (data) =>
    api({
        url: url + getIdFromSlug(data.slug) + '/related',
        data,
    });